// extracted by mini-css-extract-plugin
export default {"mobile-menu":"MainMobileMenu_mobile-menu__nb2rE","mobile-link":"MainMobileMenu_mobile-link__PWFh4"};